<template>
    <div>
        <div class="share-box" @click="copyToClipboard">
            <div class="content">{{ content }}</div>

            <div v-tooltip="content" class="copy">
                <span
                    class="vrm-table__link__icon vrm-table__link__icon--dark sg-vrm-icon_095_report_16px"
                />
            </div>

            <div style="clear: both;"></div>
        </div>

        <div v-if="copied" class="vrm-tooltip" style="align-self: end;">
            <div class="vrm-tooltip__content">Copied!</div>
        </div>
    </div>
</template>
<style scoped>
.share-box {
    background-color: #3c3c3c;
    border: 1px solid rgb(var(--grey-darker));
    border-radius: 0.5rem;
    color: #fff;
    padding: 1.5rem;
    cursor: pointer;
    overflow-wrap: anywhere;
}

.share-box {
    display: flex;
}

.share-box .copy {
    width: 2.4rem;
    right: 0;
    margin-left: 1rem;
}

.share-box .content {
    flex-grow: 1;
}
</style>
<script>
import { Vue, Prop, Component } from 'vue-property-decorator';

@Component
export default class VrmShareBox extends Vue {
    @Prop({ required: true })
    content;

    copied = false;

    copyToClipboard() {
        this.copied = true;

        navigator.clipboard.writeText(this.content);

        let t = this;
        // Close the tooltip
        setTimeout(function() {
            t.copied = false;
        }, 1000);
    }
}
</script>
